import axios from "axios";
import { AppUtils, CookieUtils } from "utils";
// import AppUtils from "utils/AppUtils";
// import CookieUtils from "utils/CookieUtils";
import Router from "next/router";

class jwtService extends AppUtils.EventEmitter {
  constructor(props) {
    super(props);

    this.afterLoginToken = null;
    this.afterLoginUserId = null;
  }

  init() {
    // this.setInterceptors();
    this.handleAuthentication();
    axios.defaults.headers.common["isResponseJson"] = true;
    axios.defaults.headers.common["Accept-Language"] = "fa-ir";
  }

  setInterceptors = () => {
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (err) => {
        return new Promise((resolve, reject) => {
          if (!navigator.onLine) return;

          if (
            (err.response.status === 401 || err.response.status === 403 )&&
            err.config &&
            !err.config.__isRetryRequest
          ) {
            // if you ever get an unauthorized response, logout the user
            this.emit("onAutoLogout", "Invalid access_token");
            this.setSession(null);
          }
          throw err;
        });
      }
    );
  };

  handleAuthentication = (req) => {
    const cookieInstance = new CookieUtils();
    let access_token = cookieInstance.getCookie("jwt_access_token", req);
    let userId = cookieInstance.getCookie("userId", req);
    if(access_token){
      this.setSession({ token: access_token, userId });
      this.emit("onAutoLogin", true);
    }

    // if (!access_token) {
    //   this.emit("onAutoLogout", "Invalid access_token");
    //   this.setSession(null);
    // } else {
    //   if (Router.pathname === "/login") {
    //     Router.push({
    //       pathname:
    //         process.env.NEXT_PUBLIC_APP_TYPE === "teacher" ? "/teacher" : "/",
    //     });
    //   }
    //   this.setSession({ token: access_token, userId });
    //   this.emit("onAutoLogin", true);
    // }
  };

  signInWithMobile = ({ UserName, AppType }) => {
    return new Promise((resolve, reject) => {
      // const data = process.env.NEXT_PUBLIC_APP_TYPE === "teacher"
      // axios
      //   .post(`${process.env.NEXT_PUBLIC_APP_URL}/api/User/Login`, {
      //     UserName,
      //     AppType,
      //   })
      axios({
        method: process.env.NEXT_PUBLIC_APP_TYPE === "teacher" ? "get" : "post",
        url:
          process.env.NEXT_PUBLIC_APP_TYPE === "teacher"
            ? `${process.env.NEXT_PUBLIC_APP_URL}/Api/Teacher/v2/UserAuthentications/Login?cellphone=${UserName}`
            : `${process.env.NEXT_PUBLIC_APP_URL}/api/User/Login`,
        data: process.env.NEXT_PUBLIC_APP_TYPE !== "teacher" && {
          UserName,
          AppType,
        },
      }).then((response) => {
        if (response && (response.data.JsonValue || response.data.Value)) {
          const data =
            process.env.NEXT_PUBLIC_APP_TYPE === "teacher"
              ? response.data.Value
              : response.data.JsonValue;
          // TODO: add logger later
          console.log(response, response.data.Message);
          // this.setSession({ token: data.Token, userId: data.UserID });
          this.afterLoginToken = data.Token;
          this.afterLoginUserId = data.UserID;
          resolve(data);
        } else {
          reject(response.data.Message);
        }
      });
    });
  };

  signInWithToken = ({ token, type, cellphone }) => {
    return new Promise((resolve, reject) => {
      const url =
        process.env.NEXT_PUBLIC_APP_TYPE === "teacher"
          ? `${process.env.NEXT_PUBLIC_APP_URL}/Api/Teacher/v2/UserAuthentications/CheckToken?cellphone=${cellphone}&smsCode=${token}`
          : `${process.env.NEXT_PUBLIC_APP_URL}/api/User/CheckToken?token=${token}&type=${type}`;
      axios
        .get(url, {
          headers: {
            key: this.afterLoginToken,
            userId: this.afterLoginUserId,
            isResponseJson: true,
          },
        })
        .then((response) => {
          if (response && (response.data.JsonValue || response.data.Value)) {
            const data =
              process.env.NEXT_PUBLIC_APP_TYPE === "teacher"
                ? response.data.Value
                : response.data.JsonValue;
            // const data = JSON.parse(response.data.Value);
            // TODO: add logger later
            this.setSession({ token: data.Token, userId: data.UserID });
            resolve(data);
          } else {
            reject(response.data.Message);
          }
        });
    });
  };

  updateUserData = ({ Cellphone, Phone1, Address }) => {
    return axios.post(
      `${process.env.NEXT_PUBLIC_APP_URL}/api/User/UpdateUser`,
      { Cellphone, Phone1, Address }
    );
  };

  setSession = (sessionData) => {
    if (sessionData) {
      const { token, userId } = sessionData;
      CookieUtils.setCookie("jwt_access_token", token);
      CookieUtils.setCookie("userId", userId);
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      axios.defaults.headers.common["key"] = token;
      axios.defaults.headers.common["userid"] = userId;
    } else {
      CookieUtils.removeCookie("jwt_access_token");
      CookieUtils.removeCookie("userId");
      delete axios.defaults.headers.common["key"];
      delete axios.defaults.headers.common["userid"];
      delete axios.defaults.headers.common["Authorization"];
    }
  };

  logout = () => {
    this.setSession(null);
  };
}

const instance = new jwtService();

export default instance;
